module.exports = __webpack_public_path__ + "static/img/increment05.5be6f5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/increment05.png
// module id = EqrN
// module chunks = 0